import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useOnboarding } from 'contexts/OnboardingContext';
import { getTemplate } from 'api/users';

/**
 * SocialSignInHandler is a component that manages the user onboarding process
 * after a social sign-in. It checks if the user is new by reading the URL's
 * search parameters and triggers the onboarding process if necessary.
 * Specifically, it opens a resume onboarding popup for new users and then
 * cleans the URL to remove the 'new_user' parameter, ensuring the popup
 * does not reappear on page refresh. This component does not render any UI.
 */

const SocialSignInHandler = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setShouldShowOnboarding } = useOnboarding();


    useEffect(() => {
        const isNewUser = searchParams.get('new_user');

        const fetchTemplate = async () => {
            try {
                const response = await getTemplate();
                if (response?.success && response.data) {
                    const candidate = response?.data;
                    console.log(candidate?.template);
                    if (candidate && !candidate?.template) setShouldShowOnboarding(true);
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (isNewUser === 'true') {
            // 1. Open the resume onboarding popup
            // openResumeOnboarding();
            setShouldShowOnboarding(true);

            // 2. Clean the URL to remove the parameter.
            // This is CRITICAL to prevent the popup from showing again on refresh.
            // `replace: true` tells the router to replace the current history entry
            // instead of adding a new one.
            navigate(location.pathname, { replace: true });
        } else {
            fetchTemplate();
        }
    }, []);

    // This component renders nothing, it only handles logic
    return null;
};

export default SocialSignInHandler;